import {
  GET_SCHEDULED_STREAMS,
  GET_SCHEDULED_STREAMS_SUCCESS,
  GET_SCHEDULED_STREAMS_ERROR,
  GET_SCHEDULED_STREAM,
  GET_SCHEDULED_STREAM_SUCCESS,
  GET_SCHEDULED_STREAM_ERROR,
  CREATE_SCHEDULED_STREAM,
  CREATE_SCHEDULED_STREAM_SUCCESS,
  CREATE_SCHEDULED_STREAM_ERROR,
  UPDATE_SCHEDULED_STREAM,
  UPDATE_SCHEDULED_STREAM_SUCCESS,
  UPDATE_SCHEDULED_STREAM_ERROR,
  DELETE_SCHEDULED_STREAM,
  DELETE_SCHEDULED_STREAM_SUCCESS,
  SIGN_UP_FOR_STREAM,
  SIGN_UP_FOR_STREAM_SUCCESS,
  SIGN_UP_FOR_STREAM_ERROR,
} from './constants';

const initialState = {
  loading: false,
  streams: [],
  selectedStream: null,
  error: null,
  success: false,
};

const scheduledStream = (state = initialState, action) => {
  switch (action.type) {
    case GET_SCHEDULED_STREAMS:
    case GET_SCHEDULED_STREAM:
    case CREATE_SCHEDULED_STREAM:
    case UPDATE_SCHEDULED_STREAM:
      return {
        ...state,
        loading: true,
        error: null,
        success: false,
      };

    case GET_SCHEDULED_STREAMS_SUCCESS:
      return {
        ...state,
        loading: false,
        streams: action.payload,
      };

    case GET_SCHEDULED_STREAM_SUCCESS:
      return {
        ...state,
        loading: false,
        selectedStream: action.payload,
      };

    case CREATE_SCHEDULED_STREAM_SUCCESS:
      return {
        ...state,
        loading: false,
        success: true,
        streams: [...state.streams, action.payload.stream],
      };

    case UPDATE_SCHEDULED_STREAM_SUCCESS:
      return {
        ...state,
        loading: false,
        success: true,
        streams: state.streams.map((stream) =>
          stream._id === action.payload._id ? action.payload : stream
        ),
      };
    case SIGN_UP_FOR_STREAM_SUCCESS:
      return {
        ...state,
        streams: state.streams.map((stream) =>
          stream._id === action.payload._id ? action.payload : stream
        ),
        success: true,
      };
    case SIGN_UP_FOR_STREAM_ERROR:
      return {
        ...state,
        error: action.error,
        success: false,
      };
    case DELETE_SCHEDULED_STREAM:
      return {
        ...state,
        loading: false,
        success: true,
        streams: state.streams.filter((stream) => stream._id !== action.id),
      };
    case DELETE_SCHEDULED_STREAM_SUCCESS:
      return {
        ...state,
        loading: false,
        success: true,
      };
    case GET_SCHEDULED_STREAMS_ERROR:
    case GET_SCHEDULED_STREAM_ERROR:
    case CREATE_SCHEDULED_STREAM_ERROR:
    case UPDATE_SCHEDULED_STREAM_ERROR:
      return {
        ...state,
        loading: false,
        error: action.error,
        success: false,
      };

    default:
      return state;
  }
};

export default scheduledStream;
